<template>
  <div class="traffic-page dark-theme">
    <!-- 主内容区 -->
    <div class="traffic-container">
      <!-- 流量统计卡片 -->
      <div class="section-card">
        <div class="card-header">
          <a-icon type="line-chart" class="card-icon" />
          <h3 class="card-title">{{ translate('traffic.title') }}</h3>
        </div>

        <div class="search-section">
          <a-form
            :model="formData"
            @submit.prevent="onSubmit"
            layout="inline"
            class="search-form"
          >
            <a-form-item :label="translate('traffic.form.subAccount')" class="dark-form-item">
              <a-select
                v-model="formData.uname"
                :placeholder="translate('traffic.form.selectSubAccount')"
                style="min-width: 300px"
                allow-clear
                @change="changeSon"
                @clear="handleClear"
                class="dark-select"
              >
                <a-select-option value="all">{{ translate('traffic.form.all') }}</a-select-option>
                <a-select-option
                  v-for="item in sonlist"
                  :key="item.upid"
                  :value="item.username"
                >
                  {{ item.username }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item>
              <a-button type="primary" @click="onSubmit" class="action-btn">{{ translate('traffic.form.search') }}</a-button>
            </a-form-item>
          </a-form>
        </div>

        <!-- echarts图表容器 -->
        <div
          id="traffic-chart"
          class="traffic-chart"
          style="width: 100%; height: 520px"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { message } from 'ant-design-vue'
import * as echarts from 'echarts'

export default {
  name: 'TrafficPage',
  inject: ['languageState'],
  computed: {
    currentLanguage() {
      return this.languageState ? this.languageState.languageCode : 'zh';
    },
  },
  data() {
    return {
      form: this.$form.createForm(this),
      formData: {
        uname: 'all',
      },
      timer: '', // 定时器名称
      sonlist: [],
      flowlist: [],
      timelist: [],
      uid: localStorage.getItem('userId'),
      charts: null,
    }
  },
  watch: {
    'formData.uname'(newVal) {
      if (newVal === undefined || newVal === null) {
        this.formData.uname = 'all'
      }
    }
  },
  methods: {
    // 国际化翻译方法
    translate(key) {
      const lang = this.currentLanguage;
      const translations = {
        'traffic.title': lang === 'zh' ? '流量使用概括' : 'Traffic Usage Summary',
        'traffic.form.subAccount': lang === 'zh' ? '子账户' : 'Sub Account',
        'traffic.form.selectSubAccount': lang === 'zh' ? '请选择子账户' : 'Please select sub account',
        'traffic.form.all': lang === 'zh' ? '全部' : 'All',
        'traffic.form.search': lang === 'zh' ? '查询' : 'Search',
        'traffic.chart.title': lang === 'zh' ? '流量使用趋势' : 'Traffic Usage Trend',
        'traffic.chart.yAxis': lang === 'zh' ? '流量(G)' : 'Traffic (G)',
        'traffic.message.loginWarning': lang === 'zh' ? '请重新登录！' : 'Please login again!',
      };
      return translations[key] || key;
    },
    // 登录状态检查
    getLoginStatus() {
      this.$request.get('/ums/isLoginStates').then((res) => {
        if (res.data.code === 5000) {
          this.$router.push('/login')
          window.localStorage.clear()
          message.warning(this.translate('traffic.message.loginWarning'))
        }
      })
        .catch((e) => {
          console.log(e)
        })
    },
    // 启动定时检查
    start() {
      this.timer = setInterval(this.getLoginStatus, 10000)
    },
    // 初始化图表
    initChart(id) {
      if (!this.charts || this.charts.isDisposed()) {
        this.charts = echarts.init(document.getElementById(id))
      }
    },
    // 更新图表数据
    updateChart(data) {
      if (!this.charts) {
        this.initChart('traffic-chart')
      }
      
      if (this.charts) {
        this.flowlist = []
        this.timelist = []
        data.forEach((item) => {
          this.flowlist.push(item.flowOverdueChange)
          this.timelist.push(item.createrTime)
        })
        
        this.charts.setOption({
          backgroundColor: 'transparent',
          title: {
            left: '3%',
            top: '2%',
            text: this.translate('traffic.chart.title'),
            textStyle: {
              color: '#ffffff',
              fontSize: 16,
              fontWeight: 600,
            },
          },
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(30, 41, 59, 0.95)',
            borderColor: 'rgba(21, 129, 198, 0.3)',
            borderWidth: 1,
            textStyle: {
              color: '#ffffff',
            },
            axisPointer: {
              type: 'line',
              lineStyle: {
                color: 'rgba(21, 129, 198, 0.5)',
              },
              crossStyle: {
                color: 'rgba(21, 129, 198, 0.5)',
              },
            },
          },
          grid: {
            top: '20%',
            left: '5%',
            right: '5%',
            bottom: '5%',
            containLabel: true,
          },
          xAxis: {
            type: 'category',
            boundaryGap: true,
            axisLine: {
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.3)',
              },
            },
            axisTick: {
              alignWithLabel: true,
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.3)',
              },
            },
            axisLabel: {
              color: 'rgba(255, 255, 255, 0.7)',
              fontSize: 12,
            },
            data: this.timelist,
          },
          yAxis: {
            name: this.translate('traffic.chart.yAxis'),
            nameTextStyle: {
              color: 'rgba(255, 255, 255, 0.7)',
              fontSize: 12,
            },
            type: 'value',
            boundaryGap: true,
            axisLine: {
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.3)',
              },
            },
            axisTick: {
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.3)',
              },
            },
            axisLabel: {
              color: 'rgba(255, 255, 255, 0.7)',
              fontSize: 12,
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.1)',
              },
            },
          },
          series: [{
            type: 'line',
            data: this.flowlist,
            smooth: true,
            lineStyle: {
              width: 3,
              color: '#1581c6',
            },
            itemStyle: {
              radius: 6,
              color: '#1581c6',
              borderColor: '#000000',
              borderWidth: 2,
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: 'rgba(21, 129, 198, 0.3)'
                }, {
                  offset: 1, color: 'rgba(21, 129, 198, 0.05)'
                }],
              },
            },
            emphasis: {
              itemStyle: {
                radius: 8,
                shadowColor: 'rgba(21, 129, 198, 0.5)',
                shadowBlur: 10,
              },
            },
          }],
        }, true)
      }
    },
    // 绘制折线图
    drawLine(id) {
      this.initChart(id)
      this.fetchTrafficData()
    },
    // 获取流量数据
    fetchTrafficData() {
      this.$request.get(`/his/polyline?uname=${this.formData.uname}&uid=${this.uid}`).then((res) => {
        if (res.data.code === 200) {
          this.updateChart(res.data.data)
        }
      }).catch((e) => { console.log(e) })
    },
    // 子账户变化监听
    changeSon() {
      this.$request.get(`/ums/Pro/selectSonAccount?id=${this.uid}`).then((res) => {
        if (res.data.code === 200) {
          this.sonlist = res.data.data
        }
      }).catch((e) => { console.log(e) })
    },
    // 查询提交
    onSubmit() {
      this.fetchTrafficData()
    },
    // 处理清空事件
    handleClear() {
      this.formData.uname = 'all'
    },
    // 窗口大小变化处理函数
    handleResize() {
      if (this.charts) {
        this.charts.resize()
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.drawLine('traffic-chart')
    })
    this.changeSon()
    this.start()
    // 添加窗口大小变化事件监听器
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
    if (this.charts) {
      this.charts.dispose()
    }
    // 移除窗口大小变化事件监听器
    window.removeEventListener('resize', this.handleResize)
  },
}
</script>

<style scoped lang="less">
// 深色主题全局样式
.dark-theme {
  background: #2d2c28;
  color: #ffffff;
  // min-height: 100vh;
}

// 主容器样式
.login-record-container, .flow-record-container, .sub-account-container, .traffic-container {
  padding: 20px;
  margin: 0 auto;
}

// 卡片通用样式
.section-card {
  background: #33342e;
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  color: #ffffff !important;

  &:hover {
    border-color: rgba(21, 129, 198, 0.3);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    transform: translateY(-2px);
  }
}

// 卡片头部
.card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.card-icon {
  font-size: 20px;
  color: #00ea90;
  background: rgba(0, 234, 144, 0.1);
  padding: 8px;
  border-radius: 8px;
}

.card-title {
  font-size: 18px;
  font-weight: 700;
  color: #ffffff !important;
  margin: 0;
}

// 操作区/搜索区
.action-bar, .search-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding: 20px;
  background: #1f1e1b;
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
}

.search-form {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.dark-form-item {
  :deep(.ant-form-item-label > label) {
    color: rgba(255, 255, 255, 0.9) !important;
    font-weight: 500;
  }
}

// 统计项
.master-stats {
  display: flex;
  gap: 20px;
}
.stat-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.stat-label {
  font-size: 14px;
  color: #aaa;
}
.stat-value {
  font-size: 18px;
  font-weight: 700;
  color: #00ea90;
}

// 表单元素暗黑风
:deep(.ant-input),
:deep(.ant-input-number),
:deep(.ant-input-password input),
:deep(.ant-select-selection),
:deep(.ant-select-selector),
:deep(.ant-select-selection--single) {
  background: #1f1e1b !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  border-radius: 8px !important;
  color: #fff !important;
  height: 40px !important;
  transition: all 0.3s ease !important;
  box-shadow: none !important;
}

:deep(.ant-select-selection__rendered) {
  line-height: 38px !important;
  color: #fff !important;
}

:deep(.ant-input:hover),
:deep(.ant-input-number:hover),
:deep(.ant-select-selection:hover) {
  border-color: #1581c6 !important;
}

:deep(.ant-input:focus),
:deep(.ant-input-number:focus),
:deep(.ant-select-focused .ant-select-selection) {
  border-color: #00ea90 !important;
  box-shadow: 0 0 0 2px rgba(0, 234, 144, 0.2) !important;
}

:deep(.ant-select-dropdown) {
  background: #33342e !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
}
:deep(.ant-select-dropdown-menu-item) {
  color: #ddd !important;
}
:deep(.ant-select-dropdown-menu-item-active),
:deep(.ant-select-dropdown-menu-item-selected) {
  background: rgba(21, 129, 198, 0.2) !important;
  color: #fff !important;
}

// 按钮暗黑风
:deep(.ant-btn-primary) {
  background: #1581c6 !important;
  border-color: #1581c6 !important;
  border-radius: 8px;
  height: 40px;
  font-weight: 600;
  color: #fff !important;
}

:deep(.ant-btn-primary:hover) {
  background: #126ba5 !important;
  border-color: #126ba5 !important;
}

:deep(.ant-btn-danger) {
  background: #f5222d !important;
  border-color: #f5222d !important;
  border-radius: 8px;
  height: 40px;
  color: #fff !important;
}
:deep(.ant-btn-danger:hover) {
  background: #cf1322 !important;
  border-color: #cf1322 !important;
}

.action-btn {
  background: #1581c6 !important;
  border: none !important;
  padding: 0 24px !important;
  border-radius: 8px !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  color: #ffffff !important;
  height: 40px !important;
  transition: all 0.3s ease !important;

  &:hover {
    transform: translateY(-1px) !important;
    box-shadow: 0 4px 12px rgba(21, 129, 198, 0.3) !important;
  }
}

// 深色表格样式
.dark-table {
  background: transparent !important;
  color: #ffffff !important;

  :deep(.ant-table) {
    background: transparent !important;
  }

  :deep(.ant-table-thead > tr > th) {
    background: #1f1e1b !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05) !important;
    color: rgba(255, 255, 255, 0.8) !important;
    font-weight: 700 !important;
    font-size: 14px;
    padding: 16px 12px;
  }

  :deep(.ant-table-tbody > tr) {
    background: transparent !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05) !important;
  }

  :deep(.ant-table-tbody > tr > td) {
    color: rgba(255, 255, 255, 0.7) !important;
    font-size: 14px;
    padding: 16px 12px;
    background: #2d2c28 !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05) !important;
  }

  :deep(.ant-table-tbody > tr:hover > td) {
    background: rgba(21, 129, 198, 0.2) !important;
  }

  :deep(.ant-pagination) {
    color: rgba(255, 255, 255, 0.6) !important;
  }

  :deep(.ant-pagination-item) {
    background: #1f1e1b !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
  }

  :deep(.ant-pagination-item a) {
    color: rgba(255, 255, 255, 0.6) !important;
  }

  :deep(.ant-pagination-item-active) {
    background: linear-gradient(135deg, #1581c6 0%, #00ea90 100%) !important;
    border-color: transparent !important;
  }

  :deep(.ant-pagination-item-active a) {
    color: #ffffff !important;
  }

  :deep(.ant-empty) {
    color: rgba(255, 255, 255, 0.5) !important;
    background: #1f1e1b !important;
    border: 1px solid rgba(255, 255, 255, 0.05) !important;
    border-radius: 8px;
    padding: 40px 20px !important;
    margin: 20px 0 !important;
  }

  :deep(.ant-empty-description) {
    color: rgba(255, 255, 255, 0.5) !important;
  }
}

// 模态框深色样式
:deep(.ant-modal-content) {
  background: #33342e !important;
  color: #fff;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.05);
}
:deep(.ant-modal-header) {
  background: #2d2c28 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px 12px 0 0;
}
:deep(.ant-modal-title) {
  color: #fff !important;
  font-weight: 700;
}
:deep(.ant-modal-close-x) {
  color: #aaa !important;
}
:deep(.ant-modal-close:hover .ant-modal-close-x) {
  color: #fff !important;
}
:deep(.ant-form-item-label > label) {
  color: #ddd !important;
}

// 图表样式
.traffic-chart {
  border-radius: 16px;
  background: #1f1e1b !important;
  border: 1px solid rgba(255, 255, 255, 0.05) !important;
  padding: 20px;
  height: 520px !important;
  width: 100% !important;
}

// 响应式设计
@media (max-width: 768px) {
  .login-record-container, .flow-record-container, .sub-account-container, .traffic-container {
    padding: 16px;
  }

  .action-bar, .search-section {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }

  .dark-table {
    :deep(.ant-table-thead > tr > th),
    :deep(.ant-table-tbody > tr > td) {
      padding: 12px 8px;
    }
  }
}
</style>